export const PATIENT_SEARCH_COLUMNS = [
    { value: 'firstName', label: 'First Name', icon: 'bi-person' },
    { value: 'lastName', label: 'Last Name', icon: 'bi-person-badge' },
    { value: 'email', label: 'Email', icon: 'bi-envelope' },
    { value: 'preferredName', label: 'Preferred Name', icon: 'bi-person-heart' },
    { value: 'phoneNumber', label: 'Home Phone', icon: 'bi-telephone' },
    { value: 'cellNumber', label: 'Cell Phone', icon: 'bi-phone' },
    { value: 'pmsId', label: 'PMS ID', icon: 'bi-hash' },
];

export const PATIENT_SORT_FIELDS = [
    { value: 'firstName', label: 'First Name' },
    { value: 'lastName', label: 'Last Name' },
    { value: 'email', label: 'Email' },
    { value: 'preferredName', label: 'Preferred Name' },
    { value: 'modifiedAt', label: 'Last Updated' },
    { value: 'createdAt', label: 'Created Date' },
    { value: 'pmsId', label: 'PMS ID' },
];

export const PAGE_SIZE_OPTIONS = [10, 20, 50];

export const DEFAULT_PATIENT_SEARCH_COLUMN = 'firstName';

export const DEFAULT_PATIENT_SORT = {
    sortBy: 'firstName',
    sortOrder: 'ASC',
};

export const DEFAULT_PATIENT_PAGE_SIZE = 20;

export const formatPatientCount = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) {
        return '0';
    }

    return number.toLocaleString();
};

const appendContainsFilter = (parts, field, value) => {
    const trimmed = value?.trim();
    if (!trimmed) {
        return;
    }

    if (field === 'pmsId' || field === 'gender') {
        parts.push(`${field}==${trimmed}`);
        return;
    }

    parts.push(`${field}==*${trimmed}*`);
};

export const buildPatientsQuery = (
    {
        searchColumn = DEFAULT_PATIENT_SEARCH_COLUMN,
        searchTerm = '',
        showAll = false,
    } = {},
    sort = DEFAULT_PATIENT_SORT
) => {
    const parts = [];

    if (!showAll) {
        appendContainsFilter(parts, searchColumn, searchTerm);
    }

    if (sort?.sortBy) {
        parts.push(`sortBy==${sort.sortBy}`);
    }

    if (sort?.sortOrder) {
        parts.push(`sortOrder==${sort.sortOrder.toUpperCase()}`);
    }

    return parts.join(',');
};
